"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateTabResultCount = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const app_1 = require("app");
const constants_1 = require("../../constants");
const useUpdateTabResultCount = (selectedTabKey, lastUserAction, update) => {
    const { results } = (0, react_instantsearch_1.useInstantSearch)();
    React.useEffect(() => {
        if ((results === null || results === void 0 ? void 0 : results['exhaustive']) === undefined) {
            return;
        }
        if (lastUserAction.name === app_1.LastUserActionNameEnum.Filter ||
            lastUserAction.name === app_1.LastUserActionNameEnum.Unfilter ||
            lastUserAction.name === app_1.LastUserActionNameEnum.ClearFilters) {
            return update(selectedTabKey, results.nbHits);
        }
        if (lastUserAction.name === app_1.LastUserActionNameEnum.Query) {
            update(constants_1.ALL_TAB_KEY);
        }
    }, [results, update, selectedTabKey, lastUserAction]);
};
exports.useUpdateTabResultCount = useUpdateTabResultCount;
